import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { DropdownIcon } from "./components";
import { changeCurrency } from "../../../actions";

const Currency = ({ current, list, changeCurrency }) => {
  if (current) {
  } else {
    current = {
      code: "INR",
      icon: "&#8377;"
    };
  }
  return (
    <Container style={{ width: "5rem" }} currency>
      {current && <Icon dangerouslySetInnerHTML={{ __html: current.icon + " " + current.code }} />}
      <DropdownIcon right />
      {list && (
        <List style={{ width: "5rem" }}>
          {list.map(currency => (
            <ListItem
              key={currency.code}
              onClick={() => changeCurrency(currency.code, current.code)}
            >
              <Icon dangerouslySetInnerHTML={{ __html: currency.icon + " " + currency.code }} />
            </ListItem>
          ))}
        </List>
      )}
    </Container>
  );
};

export const List = styled.ul`
  padding: 0;
  margin: 0;

  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  width: 100%;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background-color: #ffffff;
  list-style: none;

  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);

  max-height: 20rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: none;
  z-index: 500;
`;
export const Container = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem 0 0.2rem;
  border: 2px solid transparent;
  &:hover {
    border-bottom-color: #33cc99;
  }
  &:hover ${List} {
    display: block;
  }
`;
export const ListItem = styled.li`
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  color: #484848;
  cursor: pointer;
  &:hover {
    background-color: #f7f7f7;
  }
`;

const Icon = styled.div`
  font-weight: 400;
  color: #484848;
`;

const mapDispatchToProps = dispatch => {
  return {
    changeCurrency: (code, curr) => dispatch(changeCurrency(code, curr))
  };
};
export default connect(
  null,
  mapDispatchToProps
)(Currency);
